<div class="main-container !pt-5 pb-8">
    <div class="calculator-main-container">
        <div class="grid-test">
            <ng-template [ngTemplateOutlet]="descriptiveHeader"></ng-template>
            <ng-template *ngIf="analysisCostItems?.length > 1" [ngTemplateOutlet]="descriptiveHeader"></ng-template>
        </div>

        <div class="grid-test">
            <div class="analysis-row unit-cost-container" *ngFor="let item of analysisCostItems; let i = index">
                <span class="analysis-width">{{  item?.description ?? '-' }}</span>
                <span class="analysis-quantity">{{ item?.qty }}</span>

                <div class="analysis-cost">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Unit Price</mat-label>
                        <input (change)="calculateCost(false)" step="0.01" type="number" [(ngModel)]="item.unitPrice" matInput />
                        <span matTextPrefix>R</span>
                    </mat-form-field>
                </div>

                <span class="analysis-price">{{item?.qty * item?.unitPrice | currency:'R'}}</span>
            </div>
        </div>

        <div class="grid-test">
            <div class=" final-price-container">
                <div class="grid-test" style="padding: 10px 25px">
                    <span>Sub-Total (Nett excl. TAX)</span>
                    <span class="final-price-text">{{totalCost  | currency: 'R'}}</span>
                    <span>VAT (+15% of Nett)</span>
                    <span class="final-price-text">{{ vat | currency: 'R' }}</span>
                </div>

                <div class="grid-test total-cost-container">
                    <span>TOTAL</span>
                    <span class="final-price-text">{{totalCostWithVat | currency: 'R' }}</span>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #descriptiveHeader>
    <div class="analysis-row descriptive-header">
        <span class="analysis-width">Analysis/Service</span>
        <span class="analysis-quantity">Quantity</span>
        <span class="analysis-cost">Unit Price &nbsp; <span class="light-span">(Excl. VAT)</span></span>
        <span class="analysis-price">Price</span>
    </div>
</ng-template>
